<template>
  <div class="page-content">
    <b-field>
      <b-input v-model="route" placeholder="ROUTE" />
      <p class="control">
        <b-button label="LOAD" type="is-dark" @click="load" />
      </p>
    </b-field>

    <guide-slider :route="route" ref="guideSlider" />
  </div>
</template>

<script>
import GuideSlider from "../../../components/GuideSlider";

export default {
  components: {
    GuideSlider,
  },
  data: () => ({
    route: "",
  }),
  methods: {
    // async getSteps(page = 1) {
    //   await Vue.$stepService
    //     .getAll(`?page=${page}&topic_id=${this.topic}`)
    //     .then(async (response) => {
    //       response.data.forEach((row) => {
    //         this.stepCaptions.push(row.attributes.name);
    //         this.stepImages.push(row.attributes.path);
    //       });
    //       if (page < response.meta.pagination.total_pages) {
    //         await this.getSteps(page++);
    //       }
    //     });
    // },
    async loadSteps() {
      this.$refs.guideSlider.fetchSteps();
    },
  },
};
</script>

<style scoped>
.page-content {
  padding: 20px;
}
</style>